
import TitlePages from '../components/TitlePages'
import CardInfo from '../components/CardInfo'
import ContactInfo from '../components/Contact/ContactInfo'
export default {
  components: {
    CardInfo,
    ContactInfo,
    TitlePages
  },
  data () {
    return {
      info: 'Advance Fiber’s panels are readily available from our distributors in the main markets of Thailand, UAE, Pakistan, India, Saudi Arabia. We also ship to many other countries including Japan and Australia. Contact our sales and marketing office to discuss product and shipping options.'
    }
  }
}
